import React from 'react';
import { useParams } from 'react-router-dom';
import { articlesData } from '../data/articlesData';

function ArticlePage() {
  const { slug } = useParams();
  const article = articlesData.find(a => a.slug === slug);

  if (!article) {
    return <div style={{ padding: '2rem' }}>Article non trouvé.</div>;
  }

  return (
    <div className="article-page" style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
      <h1>{article.title}</h1>
      <p>{article.excerpt}</p>
      <div className="article-content">{article.content}</div>
    </div>
  );
}

export default ArticlePage;
